module.exports = __webpack_public_path__ + "static/media/laughing.3ddb7415.svg";